import { SUBSCRIPTION_CENTER_GROUPS } from '@/utilities/subscriptionCenter'

let customAlertsPage = true
let documentManagementPage = false
let enableMxRecTimer = true
let eventReports = true
let fleetDataPage = true
let fleetFaultsMsgsTab = true
let fleetHealthScoreTab = true
let flightDataPage = true
let maintenanceRecPage = true
let mxRecPageCustomPlots = true
let mxRecPageEditPlots = true
let mxRecPagePrepopulatedPlots = true
let navGlobalFilterButton = true
let navNotificationsButton = false
let projectZeus = true
let removalsTimeline = false
let reportDetailsExport = true
let reportListAlertColumn = true
let reportListExport = true
let reportPlots = true
let advancedCustomAlerts = true
let connectivityBanner = false
let derivedParameters = true
let powerBiPage = true
let anserToolPage = true

const subscriptionCenter = {
  active: true,
  subscriptions: SUBSCRIPTION_CENTER_GROUPS,
}

const AppFeatureFlags = {
  getCustomAlertsPage: () => customAlertsPage,
  getDocumentManagementPage: () => documentManagementPage,
  getEnableMxRecTimer: () => enableMxRecTimer,
  getEventReports: () => eventReports,
  getFleetDataPage: () => fleetDataPage,
  getFleetFaultMsgsTab: () => fleetFaultsMsgsTab,
  getFleetHealthScoreTab: () => fleetHealthScoreTab,
  getFlightDataPage: () => flightDataPage,
  getMaintenanceRecPage: () => maintenanceRecPage,
  getMxRecPageCustomPlots: () => mxRecPageCustomPlots,
  getMxRecPageEditPlots: () => mxRecPageEditPlots,
  getMxRecPagePrepopulatedPlots: () => mxRecPagePrepopulatedPlots,
  getNavGlobalFilterButton: () => navGlobalFilterButton,
  getNavNotificationsButton: () => navNotificationsButton,
  getProjectZeus: () => projectZeus,
  getRemovalsTimeline: () => removalsTimeline,
  getReportDetailsExport: () => reportDetailsExport,
  getReportListAlertColumn: () => reportListAlertColumn,
  getReportListExport: () => reportListExport,
  getReportPlots: () => reportPlots,
  getAdvancedCustomAlerts: () => advancedCustomAlerts,
  getSubscriptionCenter: () => subscriptionCenter.active,
  getSubscriptions: () => subscriptionCenter.subscriptions,
  getActiveSubscriptionIds: () =>
    subscriptionCenter.subscriptions
      .filter(subscription => subscription.visible)
      .map(subscription => subscription.id),
  getConnectivityBanner: () => connectivityBanner,
  getDerivedParameters: () => derivedParameters,
  getPowerBiPage: () => powerBiPage,
  getAnserToolPage: () => anserToolPage,
  setCustomAlertsPage: newVal => (customAlertsPage = newVal),
  setDocumentManagementPage: newVal => (documentManagementPage = newVal),
  setEnableMxRecTimer: newVal => (enableMxRecTimer = newVal),
  setEventReports: newVal => (eventReports = newVal),
  setFleetDataPage: newVal => (fleetDataPage = newVal),
  setFleetFaultMsgsTab: newVal => (fleetFaultsMsgsTab = newVal),
  setFleetHealthScoreTab: newVal => (fleetHealthScoreTab = newVal),
  setFlightDataPage: newVal => (flightDataPage = newVal),
  setMaintenanceRecPage: newVal => (maintenanceRecPage = newVal),
  setMxRecPageCustomPlots: newVal => (mxRecPageCustomPlots = newVal),
  setMxRecPageEditPlots: newVal => (mxRecPageEditPlots = newVal),
  setMxRecPagePrepopulatedPlots: newVal =>
    (mxRecPagePrepopulatedPlots = newVal),
  setNavGlobalFilterButton: newVal => (navGlobalFilterButton = newVal),
  setNavNotificationsButton: newVal => (navNotificationsButton = newVal),
  setProjectZeus: newVal => (projectZeus = newVal),
  setRemovalsTimeline: newVal => (removalsTimeline = newVal),
  setReportDetailsExport: newVal => (reportDetailsExport = newVal),
  setReportListAlertColumn: newVal => (reportListAlertColumn = newVal),
  setReportListExport: newVal => (reportListExport = newVal),
  setReportPlots: newVal => (reportPlots = newVal),
  setAdvancedCustomAlerts: newVal => (advancedCustomAlerts = newVal),
  setSubscriptionCenter: newVal => (subscriptionCenter.active = newVal),
  setSubscriptions: subscription => {
    const subscriptions = subscriptionCenter.subscriptions
    const foundSubscriptionIndex = subscriptions.findIndex(
      s => s.id === subscription.id,
    )

    if (foundSubscriptionIndex !== -1) {
      subscriptions[foundSubscriptionIndex].visible =
        !subscriptions[foundSubscriptionIndex].visible
    }
  },
  setConnectivityBanner: newVal => (connectivityBanner = newVal),
  setDerivedParameters: newVal => (derivedParameters = newVal),
  setPowerBiPage: newVal => (powerBiPage = newVal),
  setAnserToolPage: newVal => (anserToolPage = newVal),
}

Object.freeze(AppFeatureFlags)
export default AppFeatureFlags
